export default (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    details: getText('Patient details', 'Patient_Content_Header'),
    male: getText('Male', 'Patient_Content_Header'),
    female: getText('Female', 'Patient_Content_Header'),
    years: getText('years', 'Patient_Content_Header'),
    activity: getText('Recent activity', 'Patient_Content_Header'),
  }[key])
